<template>
  <div
    class="kk-option-item-layout"
    :class="`kk-option-item-layout--${inputPosition}`"
  >
    <div
      v-if="$slots.input"
      class="kk-option-item-layout__input"
    >
      <slot name="input" />
    </div>
    <div
      v-if="$slots['input-label']"
      class="kk-option-item-layout__input-label"
    >
      <slot name="input-label" />
    </div>
    <div
      v-if="$slots.children"
      class="kk-option-item-layout__children"
    >
      <slot name="children" />
    </div>
    <div
      v-if="$slots.footer"
      class="kk-option-item-layout__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'KkOptionItemLayout',
  props: {
    inputPosition: {
      type: String,
      default: 'left',
    },
  },
};
</script>
